import { connectV1Client } from './BaseRepository';

export default function getMessages(conversationId, page = 0, size = 30) {
  return connectV1Client.post(`MessageConversations/_search`, {
    ConversationId: conversationId,
    From: page * size,
    Size: size,
  });
}
